import React, { useState } from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { StatusBar } from 'expo-status-bar';
import { DefaultTheme, Provider as PaperProvider } from 'react-native-paper';
import { useMediaQuery } from 'react-responsive';

import Footer from './components/Layout/Footer';
import Form from './components/Form/Form';
import Header from './components/Layout/Header';
import LanguageSelection from './components/LanguageSelection';
import Navigation from './components/Layout/Navigation';
import Welcome from './components/Welcome';

import { LanguageContext, languages } from './language-context';
import { PageContext, pages } from './page-context';

// import * as serviceWorkerRegistration from './sw/serviceWorkerRegistration';

const theme = {
  ...DefaultTheme,
  colors: {
    ...DefaultTheme.colors,
    primary: '#01A3CB',
    accent: '#4E4540',
    text: '#000000',
  },
};

export default function App() {
  const [currentPage, updatePage] = useState(-1);
  const [disableNextStep, toggleDisableNextStep] = useState(true);
  const [formikActions, setFormikActions] = useState(null);
  const [language, setLanguage] = useState(languages.english);

  const isTabletOrMobileDevice = useMediaQuery({
    maxDeviceWidth: 1224,
  });

  const appStyles = StyleSheet.create({
    button: {
      alignSelf: 'center',
      margin: 15,
      width: isTabletOrMobileDevice || Platform.OS !== 'web' ? '60%' : '250px',
    },
    labelStyle: {
      color: '#000000',
      fontWeight: 'bold',
    },
  });

  function updateLanguage(lang) {
    setLanguage(lang);
  }

  function stepForward() {
    updatePage(currentPage + 1);
  }

  function stepBackward() {
    updatePage(currentPage - 1);
  }

  return (
    <PaperProvider theme={theme}>
      <LanguageContext.Provider value={language}>
        <PageContext.Provider value={currentPage}>
          <View style={styles.container}>
            <Header language={language} />
            <View style={styles.body}>
              {currentPage < 0 ? (
                <LanguageSelection
                  appStyles={appStyles}
                  pageContent={pages[0].fields}
                  stepForward={stepForward}
                  updateLanguage={updateLanguage}
                />
              ) : currentPage === 0 ? (
                <Welcome
                  appStyles={appStyles}
                  pageContent={pages[1][language].fields}
                  stepForward={stepForward}
                />
              ) : (
                <Form
                  appStyles={appStyles}
                  setFormikActions={setFormikActions}
                  toggleDisableNextStep={toggleDisableNextStep}
                />
              )}
            </View>
            <View style={styles.footer}>
              {currentPage > 0 ? (
                <Navigation
                  currentPage={currentPage}
                  disableNextStep={disableNextStep}
                  formikActions={formikActions}
                  language={language}
                  stepBackward={stepBackward}
                  stepForward={stepForward}
                  updatePage={updatePage}
                />
              ) : null}
            </View>
            {Platform.OS === 'web' ? <Footer /> : null}
            <StatusBar style="auto" />
          </View>
        </PageContext.Provider>
      </LanguageContext.Provider>
    </PaperProvider>
  );
}

const styles = StyleSheet.create({
  body: { flex: 10, paddingLeft: 15, paddingRight: 15 },
  container: { flex: 1 },
  footer: { flex: 1 },
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.unregister();
